var React = require('react');

function HomeIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16 6.77859C16 6.31302 15.7924 5.87111 15.4326 5.57063L9.20909 0.373441C8.92033 0.132298 8.5545 0 8.17647 0H7.82353C7.4455 0 7.07967 0.132298 6.79091 0.373441L0.567376 5.57063C0.207565 5.87111 -5.96046e-08 6.31302 -5.96046e-08 6.77859V15.4186C-5.96046e-08 16.292 0.716344 17 1.6 17H4.68571C5.56937 17 6.28571 16.292 6.28571 15.4186V13.224C6.28571 12.976 6.35622 12.7329 6.48919 12.5225C6.73396 12.1353 7.16334 11.9 7.62532 11.9H8.3941C8.85852 11.9 9.28879 12.1412 9.52715 12.5351C9.64961 12.7376 9.71429 12.969 9.71429 13.2048V15.4186C9.71429 16.292 10.4306 17 11.3143 17H14.4C15.2837 17 16 16.292 16 15.4186V6.77859Z","fill":"#A5A9AF"}));
}

HomeIconInline.defaultProps = {"width":"16","height":"17","viewBox":"0 0 16 17","fill":"none"};

module.exports = HomeIconInline;

HomeIconInline.default = HomeIconInline;
